/*
  Lazy loading para imagens abaixo da dobra (snippets/cs-deferred-image.liquid).

  O <img> chega com um GIF transparente em src e o URL real em data-cs-src /
  data-cs-srcset, dentro de um contentor [data-cs-lazy-group]. O grupo carrega:
  - "visible" (padrão): quando está a 600px do ecrã;
  - "load": depois do evento load da página, ou na primeira interação com o grupo
    (toque, foco ou scroll dentro dele), o que acontecer primeiro.

  O loading="lazy" nativo antecipa demasiado em redes lentas (~2500px), por isso
  estas imagens competiam com a imagem principal. Sem JS fica o <noscript>.
*/
(function () {
  if (window.csLazy) return;

  function loadImage(img) {
    if (img.dataset.csSrcset) {
      img.srcset = img.dataset.csSrcset;
      img.removeAttribute('data-cs-srcset');
    }
    if (img.dataset.csSrc) {
      img.src = img.dataset.csSrc;
      img.removeAttribute('data-cs-src');
    }
  }

  function load(root) {
    if (!root) return;
    if (root.matches && root.matches('[data-cs-src]')) loadImage(root);
    root.querySelectorAll('[data-cs-src]').forEach(loadImage);
  }

  window.csLazy = { load: load };

  function init() {
    var observer =
      'IntersectionObserver' in window
        ? new IntersectionObserver(
            function (entries) {
              entries.forEach(function (entry) {
                if (!entry.isIntersecting) return;
                observer.unobserve(entry.target);
                load(entry.target);
              });
            },
            { rootMargin: '600px 0px' }
          )
        : null;

    document.querySelectorAll('[data-cs-lazy-group]').forEach(function (group) {
      if (group.dataset.csLazyBound) return;
      group.dataset.csLazyBound = 'true';

      if (group.dataset.csLazyGroup === 'load') {
        var loadGroup = function () {
          load(group);
        };
        if (document.readyState === 'complete') loadGroup();
        else window.addEventListener('load', loadGroup, { once: true });
        ['pointerdown', 'touchstart', 'focusin'].forEach(function (type) {
          group.addEventListener(type, loadGroup, { once: true, passive: true });
        });
        group.addEventListener('scroll', loadGroup, { once: true, passive: true, capture: true });
        return;
      }

      if (observer) observer.observe(group);
      else load(group);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
